import { Card, Paper } from '@material-ui/core';
import styled from 'styled-components';

export const PaperContainer = styled(Paper)`
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`;

export const DivGridFieldDataContract = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-columns: 1rem;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const DivBenefits = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
  margin-bottom: 15px;
`;

export const DivServices = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
`;

export const DivPlan = styled(DivBenefits)``;

export const DivButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 20px;
  justify-content: flex-end;
`;
// Adicione estas definições no seu arquivo styles.ts

export const PlanosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  margin-top: 16px;
`;

export const PlanoCard = styled(Card)`
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;